import * as React from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { AddressButtonSide } from '../../components/02selectwallet/addressInputComponent';
import { MetamaskMobileConnectSide } from '../../components/02selectwallet/metamaskMobileConnectComponent';
import { SwitchingButton } from '../../components/switchingButtonComponent';
import { LargeField } from '../../components/largeField';

import { CloseButtonChakra } from '../../components/closeButtonChakraComponent';
import {Center,Box,Button,Text,useDisclosure,Image} from '@chakra-ui/react';
import { useRecoilValue } from 'recoil';
import { configJsonState } from '../../states/configJsonState';


type Props = {}
export const SelectWalletPage: React.FC<Props> = (props) => {
  const configStatus = useRecoilValue(configJsonState);
  const [walletAddressText,setWalletAddressText] = React.useState(``);
  const [announceText,setAnnounceText] = React.useState(`ご自分のwalletアドレスを入力ください`);
  const SelectWalletPageComponent = styled.main`
    text-align: center;
    color: white;
    font-family: 'Noto Sans JP',sans-serif;
    background-repeat: no-repeat;
    background-size: 100% auto;
    backdrop-filter: blur(12px);
    display: grid;
    flex-wrap: wrap;
    justify-content: center;

    background-image: url(${configStatus.backgroundImage});
    height: 100vh;
  `;
  React.useEffect(()=>{
    (async() => {
      window.scrollTo(0,0);
      if (localStorage.getItem('addressofmineMM')) {
        setWalletAddressText(localStorage.getItem('addressofmineMM'));
        setAnnounceText(`前回使用したアドレスを表示中です`);
      }
    })()
  },[]);

  return (
    //※中身を入れていかないと背景が表示されない 
    <SelectWalletPageComponent>
      <Center h={`100vh`}>
        <Box>
          <Box>
            <Box 
              mb={'10px'}
              mt={'30px'}
              textAlign={'left'}
            >
              <CloseButtonChakra/>          
            </Box>
            <LargeField>
                <Box
                  backgroundColor={'orange.300'}
                  borderRadius={'100px'}
                >
                    <Text
                      color={'black'}
                      fontWeight={'bold'}
                      mb={0}
                      w={'190px'}
                      pt={'3px'}
                      pb={'3px'}
                    >MetaMask</Text>
                </Box>

                <AddressButtonSide 
                  defaultWalletAddress={walletAddressText} 
                  announceText={announceText} 
                />
            </LargeField>
          </Box>
        </Box>
      </Center>
    </SelectWalletPageComponent>
  );
};